import { render, staticRenderFns } from "./ModalEditArgs.vue?vue&type=template&id=90d1e1c2&scoped=true"
import script from "./ModalEditArgs.vue?vue&type=script&lang=js"
export * from "./ModalEditArgs.vue?vue&type=script&lang=js"
import style0 from "./ModalEditArgs.vue?vue&type=style&index=0&id=90d1e1c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d1e1c2",
  null
  
)

export default component.exports